import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { AvatarInput } from "@dzambalaorg/mui-inputs-image-firebase";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { IMutationProps, useDialogForm } from "@dzambalaorg/react-hooks";
import { ContractFeatures, ContractStatus, IContract } from "@framework/types";
import { BlockchainInfoPopover } from "@framework/shared";

import { validationSchema } from "./validation";

export interface IRaffleDialogFormProps extends IMutationProps, Pick<ReturnType<typeof useDialogForm>, "mode"> {
  open: boolean;
  selectedItem: IContract | null;
}

export const RaffleDialogForm = (props: IRaffleDialogFormProps) => {
  const { selectedItem, open, mode, ...rest } = props;

  if (!open || !selectedItem) {
    return null;
  }

  const { id, title, description, imageUrl, contractStatus, address, name, royalty, chainId, contractFeatures } =
    selectedItem;

  const fixedValues = {
    id,
    title,
    description,
    address,
    contractStatus,
    imageUrl,
  };

  return (
    <FormDialog
      open={open}
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={`dialogs.${mode}`}
      testId="RaffleContractEditForm"
      action={
        id ? (
          <BlockchainInfoPopover
            name={name}
            address={address}
            chainId={chainId}
            contractFeatures={contractFeatures}
            {...(!contractFeatures.includes(ContractFeatures.SOULBOUND) && { royalty: `${royalty / 100}%` })}
          />
        ) : null
      }
      {...rest}
    >
      <TextInput name="title" />
      <RichTextEditor name="description" />
      <SelectInput name="contractStatus" options={ContractStatus} disabledOptions={[ContractStatus.NEW]} />
      <AvatarInput name="imageUrl" />
    </FormDialog>
  );
};
